(function () {
  'use strict';

  var busy = false;
  var countTimer = null;

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function collectionRoot() {
    return qs(document, '[data-wg-collection]');
  }

  function sectionId() {
    var root = collectionRoot();
    return root ? root.getAttribute('data-section-id') : '';
  }

  function setStickyOffset() {
    var header = qs(document, '.wg-header-root');
    if (!header) return;
    document.documentElement.style.setProperty(
      '--wg-collection-sticky-top',
      Math.round(header.getBoundingClientRect().height) + 'px'
    );
  }

  function openFilters() {
    var drawer = qs(document, '[data-wg-filters-drawer]');
    if (!drawer) return;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    qsa(document, '[data-wg-filters-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
  }

  function closeFilters() {
    var drawer = qs(document, '[data-wg-filters-drawer]');
    if (!drawer) return;
    drawer.hidden = true;
    if (!qs(document, '[data-wg-sort-drawer]:not([hidden])')) {
      document.body.style.overflow = '';
    }
    qsa(document, '[data-wg-filters-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  function openSort() {
    var drawer = qs(document, '[data-wg-sort-drawer]');
    if (!drawer) return;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    qsa(document, '[data-wg-sort-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
  }

  function closeSort() {
    var drawer = qs(document, '[data-wg-sort-drawer]');
    if (!drawer) return;
    drawer.hidden = true;
    if (!qs(document, '[data-wg-filters-drawer]:not([hidden])')) {
      document.body.style.overflow = '';
    }
    qsa(document, '[data-wg-sort-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  function closeAllDrawers() {
    closeFilters();
    closeSort();
  }

  function updateHeaderCount(count) {
    var bag = qs(document, '.wg-header__bag');
    if (!bag) return;
    var badge = qs(bag, '.wg-header__count');
    var n = Number(count || 0);
    if (n > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'wg-header__count';
        bag.appendChild(badge);
      }
      badge.textContent = String(n);
    } else if (badge) {
      badge.remove();
    }
  }

  function renderUrl(url) {
    var id = sectionId();
    var next = new URL(url, window.location.origin);
    if (id) next.searchParams.set('section_id', id);
    return next.toString();
  }

  function replaceSection(html) {
    var root = collectionRoot();
    if (!root || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-wg-collection]');
    if (!next) return;
    root.replaceWith(next);
    closeAllDrawers();
    setStickyOffset();
  }

  function loadCollection(url, push, opts) {
    opts = opts || {};
    if (busy) return Promise.resolve();
    var root = collectionRoot();
    if (!root) return Promise.resolve();
    busy = true;
    root.classList.add('is-loading');
    return fetch(renderUrl(url), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('collection');
        return res.text();
      })
      .then(function (html) {
        replaceSection(html);
        if (push !== false) {
          var clean = new URL(url, window.location.origin);
          clean.searchParams.delete('section_id');
          history.pushState({ wgCollection: true }, '', clean.toString());
        }
        if (opts.scroll !== false) {
          var grid = qs(document, '[data-wg-grid-wrap]') || collectionRoot();
          if (grid) {
            var headerH = parseInt(
              getComputedStyle(document.documentElement).getPropertyValue('--wg-collection-sticky-top') || '0',
              10
            );
            var y = grid.getBoundingClientRect().top + window.scrollY - (headerH || 12) - 12;
            window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
          }
        }
      })
      .catch(function () {
        window.location.href = url;
      })
      .then(function () {
        busy = false;
        var current = collectionRoot();
        if (current) current.classList.remove('is-loading');
      });
  }

  function serializeForm(form) {
    var data = new FormData(form);
    var url = new URL(form.getAttribute('action') || window.location.pathname, window.location.origin);
    url.search = '';
    data.forEach(function (value, key) {
      if (value === '' || value == null) return;
      url.searchParams.append(key, String(value));
    });
    return url.toString();
  }

  function applyViewLabel(btn, count) {
    if (!btn) return;
    var n = Number(count || 0);
    var tpl = n === 1 ? btn.getAttribute('data-template-one') : btn.getAttribute('data-template');
    if (!tpl) return;
    btn.textContent = tpl.replace(/__N__/g, String(n));
    btn.setAttribute('data-count', String(n));
  }

  function updateDrawerCount(form) {
    var btn = qs(form, '[data-wg-filter-apply]');
    if (!btn) return;
    window.clearTimeout(countTimer);
    countTimer = window.setTimeout(function () {
      fetch(renderUrl(serializeForm(form)), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error('count');
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-wg-collection]');
          var countEl = next ? next.querySelector('[data-wg-product-count]') : null;
          var count = countEl ? countEl.getAttribute('data-count') : next && next.getAttribute('data-count');
          if (count != null) applyViewLabel(btn, count);
        })
        .catch(function () {});
    }, 180);
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-wg-filters-open]');
    if (openBtn) {
      event.preventDefault();
      closeSort();
      openFilters();
      return;
    }

    var closeBtn = event.target.closest('[data-wg-filters-close]');
    if (closeBtn) {
      event.preventDefault();
      closeFilters();
      return;
    }

    var sortOpen = event.target.closest('[data-wg-sort-open]');
    if (sortOpen) {
      event.preventDefault();
      closeFilters();
      openSort();
      return;
    }

    var sortClose = event.target.closest('[data-wg-sort-close]');
    if (sortClose) {
      event.preventDefault();
      closeSort();
      return;
    }

    var sortValue = event.target.closest('[data-wg-sort-value]');
    if (sortValue) {
      event.preventDefault();
      var form = sortValue.closest('form');
      var hidden = form ? qs(form, '[data-wg-sort-hidden], select[name="sort_by"], input[name="sort_by"]') : null;
      if (hidden) hidden.value = sortValue.getAttribute('data-wg-sort-value') || '';
      if (form) loadCollection(serializeForm(form));
      return;
    }

    var pageLink = event.target.closest('[data-wg-page-link]');
    if (pageLink && pageLink.href && collectionRoot() && pageLink.closest('[data-wg-collection]')) {
      event.preventDefault();
      loadCollection(pageLink.href);
      return;
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-wg-facets-form], [data-wg-sort-form]');
    if (!form || !collectionRoot()) return;
    event.preventDefault();
    loadCollection(serializeForm(form));
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-wg-sort]')) {
      var form = event.target.closest('form');
      if (form) loadCollection(serializeForm(form), true, { scroll: false });
      return;
    }
    if (!event.target.matches('input[type="checkbox"]')) return;
    var sidebar = event.target.closest('[data-wg-facets-form="sidebar"]');
    if (sidebar) {
      loadCollection(serializeForm(sidebar), true, { scroll: false });
      return;
    }
    var drawer = event.target.closest('[data-wg-facets-form="drawer"]');
    if (drawer) updateDrawerCount(drawer);
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-wg-facet-query]')) return;
    var wrap = event.target.closest('[data-wg-facet-search]');
    if (!wrap) return;
    var q = event.target.value.toLowerCase().trim();
    qsa(wrap, '.wg-facet__option').forEach(function (opt) {
      var label = opt.textContent.toLowerCase();
      var row = opt.closest('li');
      if (row) row.hidden = q !== '' && label.indexOf(q) === -1;
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-wg-quick-add]');
    if (!form) return;
    event.preventDefault();
    var btn = qs(form, 'button[type="submit"]');
    var idInput = qs(form, 'input[name="id"]');
    if (!idInput || !btn) return;
    var label = qs(btn, '[data-wg-cta-label]');
    var original = btn.getAttribute('data-label-add') || btn.textContent;
    btn.classList.add('is-busy');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(idInput.value), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add');
        return res.json();
      })
      .then(function () {
        if (label) label.textContent = btn.getAttribute('data-label-added') || original;
        return fetch('/cart.js').then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        if (cart) updateHeaderCount(cart.item_count);
      })
      .catch(function () {
        if (label) label.textContent = btn.getAttribute('data-label-error') || original;
      })
      .then(function () {
        window.setTimeout(function () {
          if (label) label.textContent = original;
          btn.classList.remove('is-busy');
          btn.disabled = false;
        }, 1600);
      });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllDrawers();
  });

  window.addEventListener('popstate', function () {
    if (!collectionRoot()) return;
    loadCollection(window.location.href, false, { scroll: false });
  });

  window.addEventListener('resize', setStickyOffset);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setStickyOffset);
  } else {
    setStickyOffset();
  }
})();
